import {NgModule} from '@angular/core'
import {FormComponent} from './form.component'
import {QuestionComponent} from './question/question.component'
import {SectionComponent} from './section/section.component'
import {PossibilityComponent} from './possibility/possibility.component'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {SharedModule} from '../shared/shared.module'
import {QuestionValidationComponent} from './question/validation/question-validation.component'
import {QuestionDependencyComponent} from './question/dependency/question-dependency.component'
import {QuestionDependencyDialogComponent} from './question/dependency/question-dependency-dialog.component'
import {FeatureActionsDirective, QuestionFeatureComponent} from './question/feature/question-feature.component'
import {QuestionTypeComponent} from './question/type/question-type.component'
import {QuestionValidationDocumentComponent} from './question/validation/question-validation-document.component'

@NgModule({
  declarations: [
    FormComponent,
    SectionComponent,
    QuestionComponent,
    QuestionDependencyComponent,
    QuestionDependencyDialogComponent,
    QuestionValidationComponent,
    QuestionTypeComponent,
    QuestionValidationDocumentComponent,
    PossibilityComponent,
    FeatureActionsDirective,
    QuestionFeatureComponent,
  ],
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    FormComponent
  ],
  entryComponents: [QuestionDependencyDialogComponent],
})
export class FormModule {
}
